import { createContext } from 'react';
var TableSemanticContext =
/*#__PURE__*/
createContext({});
export { TableSemanticContext };